import React from "react";
import { IWebsiteBuilderElementViewBoundingBox } from "./WebsiteBuilderElementView";
import { websiteBuilderZLayers } from "../../../../websiteBuilderZLayers";

interface IElementSelectedHighlightProps {
  selected: boolean;
  boundingBox: IWebsiteBuilderElementViewBoundingBox;
  viewResizeHandles: JSX.Element;
}

export function ElementSelectedHighlight(props: IElementSelectedHighlightProps) {
  const { selected, boundingBox, viewResizeHandles } = props;

  return (
    <>
      {selected && (
        <div
          className="website-builder-element-selected-highlight"
          style={{
            left: boundingBox.x,
            top: boundingBox.y,
            width: boundingBox.width,
            height: boundingBox.height,
            zIndex: websiteBuilderZLayers.designSpace.elementOverride,
          }}
        >
          {viewResizeHandles}
        </div>
      )}
    </>
  );
}
